declare global {
  interface Window {
    fbq: (...args: any[]) => void
    _fbq: (...args: any[]) => void
  }
}

let pixelInitialized = false

export function initMetaPixel() {
  try {
    if (typeof window === 'undefined') return
    if (pixelInitialized) return
    pixelInitialized = true

    // Set up fbq queue function
    const n: any = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    n.push = n
    n.loaded = !0
    n.version = '2.0'
    n.queue = []

    window.fbq = n
    window._fbq = n

    // Queue init and PageView immediately
    window.fbq('init', '1284151853554260')
    window.fbq('track', 'PageView')

    // Load the fbevents.js script
    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    script.onerror = () => {
      // Script failed to load — pixel won't fire but app continues
      console.warn('Meta Pixel script failed to load')
    }
    document.head.appendChild(script)

    // Noscript pixel fallback — defer until body is available
    const addFallbackPixel = () => {
      try {
        const img = document.createElement('img')
        img.height = 1
        img.width = 1
        img.style.display = 'none'
        img.src =
          'https://www.facebook.com/tr?id=1284151853554260&ev=PageView&noscript=1'
        document.body.appendChild(img)
      } catch {
        // Silently fail if body not available
      }
    }

    if (document.body) {
      addFallbackPixel()
    } else {
      window.addEventListener('DOMContentLoaded', addFallbackPixel)
    }
  } catch {
    console.warn('Meta Pixel initialization failed')
  }
}

export function trackAddToCart() {
  try {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'CERO DECISIONES - Tu Comida Lista',
        content_type: 'product',
        value: 6.39,
        currency: 'USD',
      })
    }
  } catch {
    console.warn('Meta Pixel AddToCart tracking failed')
  }
}
